import {useGame} from "../contexts/GameContext";
import React, {useEffect} from "react";
import {useMute} from "../contexts/MuteContext";
import {audioEngine} from "./audioMap";
import {TimepassSDK} from "../assets/images/TimepassAPI/TimepassSDK";
import WinnerBanner from "./banner";

const PrizeWinner = () => {
    const {prizeWinner, setPrizeWinner, prizes, players, prizeWinners} = useGame();
    const {isMuted} = useMute();
    const urlParams = new URLSearchParams(window.location.search);
    const playerId = urlParams.get('playerId');
    useEffect(() => {
        const images = ["./bg-lost.svg", "./bg-won.svg", "./leaderboard-title.svg", "./cross.png"];
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);
    useEffect(() => {
        if (prizeWinner?.prizeId) {

            if (!isMuted) {
                if (prizeWinner.playerId === playerId) {
                    audioEngine.playSFX("winner");
                    try {
                        TimepassSDK.getInstance().sendHapticFeedback()
                    } catch (e) {
                        console.error(e);
                    }
                } else {
                    audioEngine.playSFX("loser");
                }
            }

            setTimeout(() => {
                setPrizeWinner(null);
            }, 2000);
        }
    }, [prizeWinner?.prizeId]);

    if (!prizeWinner) return null;

    const prize = prizes.find(p => p.id === prizeWinner.prizeId);
    const player = players.find(p => p.id === prizeWinner.playerId);
    if (!prize || !player) return null;

    const pointsMap: Record<string, number> = {};
    players.forEach(player => {
        pointsMap[player.id] = 0;
    });
    prizeWinners.forEach(({ prize, player }) => {
        if (player?.playerId) {
            pointsMap[player.playerId] += prize.points;
        }
    });

    const rankedPlayers = [...players]
        .map(p => ({
            ...p,
            points: pointsMap[p.id] || 0,
        }))
        .sort((a, b) => b.points - a.points);

    const rankMap: Record<string, number> = {};
    rankedPlayers.forEach((p, idx) => {
        rankMap[p.id] = idx + 1;
    });


    return (
        <WinnerBanner prize={prize.name} prizePoints={prize.points} isOpponent={prizeWinner.playerId !== playerId} playerSocialID = {player.name as string} avatar={player.profile} />
    );
};


export default PrizeWinner;